import { useStore } from 'effector-react'
import * as React from 'react'

import { $error, loginByEmail, mounted } from './model'

export const useLoginByEmailPage = () => {
  React.useEffect(() => {
    mounted()
  }, [])

  const error = useStore($error)

  const loading = useStore(loginByEmail.pending)

  return {
    form: {
      error,
      loading,
    },
  }
}
